import React from "react";
import { toPlainText } from "@portabletext/toolkit";

interface IFaqItem {
  _key: string;
  question: string;
  _rawAnswer: any;
}

interface IProps {
  faqItems: IFaqItem[];
}

const FaqSchema = ({ faqItems }: IProps) => {
  const validItems = faqItems.filter(
    (item) => item.question && item._rawAnswer?.length
  );

  if (!validItems.length) {
    return null;
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: validItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: toPlainText(item._rawAnswer),
      },
    })),
  };

  return (
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  );
};

export default FaqSchema;
